<template>
  <email-form-modal
    :modal-id="modalId"
    title="Email Technician Payment"
    :initial-emails="email ? [email] : null"
    :initial-form="initialForm"
    :request="submitRequest"
    @success="(technicianPayment) => $emit('input', technicianPayment)"
  >
    <template #fields="{ form }">
      <b-row>
        <b-col cols="12">
          <b-form-group label-for="technician-payment-email-cc_manager">
            <b-form-checkbox
              id="technician-payment-email-cc_manager"
              v-model="form.cc_manager"
            >
              CC Manager
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </email-form-modal>
</template>

<script>
import EmailFormModal from '@/components/shared/EmailFormModal.vue';

export default {
  name: 'TechnicianPaymentsEmailModal',
  components: {
    EmailFormModal,
  },
  props: {
    value: Object,
    email: String,
    cc_manager: Boolean,
  },
  data() {
    return {
      modalId: 'technician-payment-email-modal',
    };
  },
  computed: {
    initialForm() {
      return {
        cc_manager: this.cc_manager,
      };
    },
  },
  methods: {
    submitRequest(payload) {
      return this.$technicianPaymentsAPI.email(this.value.id, payload);
    },
  },
};
</script>
